import type { PageRoute } from '@/lib/types';

const basePath = '/login';

const route: PageRoute = {
    basePath,
    path: basePath,
    title: 'Login',
};

export default route;
